class CollectionBuilder extends HTMLElement {
  constructor() {
    super();

    this.submitButton = this.querySelector('#collection-builder-submit');
    this.measure = this.querySelector('#invisible-measure');
    if (!this.submitButton) return;

    this.selects = this.querySelectorAll('select');
    this.selects.forEach(select => {
      this.resizeSelect(select);
    });
    this.selects.forEach(select => {
      select.addEventListener('change', () => this.resizeSelect(select));
    });

    this.submitButton.addEventListener('click', () => this.buildCollectionUrl());
  }

  resizeSelect(select) {
    this.measure.textContent = select.options[select.selectedIndex].text;

    select.style.width = `${this.measure.offsetWidth}px`;
  }

  buildCollectionUrl() {
    const tag1Select = document.querySelector('#tag-type-1');
    const tag2Select = document.querySelector('#tag-type-2');
    const tag3Select = document.querySelector('#tag-type-3');

    const tag1 = tag1Select?.value || '';
    const tag1_type = tag1Select.dataset.tag || '';
    const tag2 = tag2Select?.value || '';
    const tag2_type = tag2Select.dataset.tag || '';
    const tag3 = tag3Select?.value || '';
    const tag3_type = tag3Select.dataset.tag || '';

    if (!tag1 && !tag2 && !tag3) {
      return;
    }

    console.log(`${tag1_type} + ${tag2_type} + ${tag3_type}`);

    const baseCollectionUrl = '/collections/all-products?sort_by=best-selling';
    // /collections/all?sort_by=title-ascending&filter.p.m.custom.skin_concerns=Dry&filter.p.m.custom.skin_concerns=Redness&filter.p.m.custom.product_type=SPF

    const filterParams = [];
  
    if (tag1 && tag1_type) {
      filterParams.push(`filter.p.m.custom.${tag1_type}=${tag1}`);
    }
    
    if (tag2 && tag2_type) {
      filterParams.push(`filter.p.m.custom.${tag2_type}=${tag2}`);
    }
    
    if (tag3 && tag3_type) {
      filterParams.push(`filter.p.m.custom.${tag3_type}=${tag3}`);
    }

    // Combine into final URL
    const collectionUrl = filterParams.length 
      ? `${baseCollectionUrl}&${filterParams.join('&')}`
      : baseCollectionUrl;

    console.log('Navigating to:', collectionUrl);
    window.location.href = collectionUrl;
  }
}

customElements.define('collection-builder', CollectionBuilder);
